import EditDocumentIcon from '@mui/icons-material/Dock'

const Icon = () => {
  return (
    <EditDocumentIcon
      htmlColor='#E62E30'
      fontSize='large'
    />
  )
}

export default Icon
